import { render } from "./BudgetReport.vue?vue&type=template&id=669c66b3&scoped=true"
import script from "./BudgetReport.vue?vue&type=script&lang=js"
export * from "./BudgetReport.vue?vue&type=script&lang=js"

import "./BudgetReport.vue?vue&type=style&index=0&id=669c66b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669c66b3"]])

export default __exports__